import { HERO_SECTIONS, HERO_SECTIONS_BY_KEY } from "@/content/data";
import type { HeroSection, Key, KeyList } from "@/content/types";

type GetHeroSectionOptions = {
  limit?: number;
};

export function getHeroSections(
  keys?: KeyList,
  options?: GetHeroSectionOptions,
): HeroSection[] {
  if (!keys) {
    return HERO_SECTIONS.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => HERO_SECTIONS_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}

export function getHeroSection(key: Key): HeroSection {
  return HERO_SECTIONS_BY_KEY[key];
}
